<app-ui-select
  class="dashboard-period-select"
  [label]="'timePeriod' | translate"
  [control]="periodControl"
  [options]="periodOptions"
  [isMultiple]="false"
  [enableSearch]="false"
  [compactOnMobile]="true"
  [triggerLabel]="customRangeDisplayText"
  panelClass="dashboard-period-select-panel"
  (changeHandler)="onPeriodChange($event)"
  (optionClick)="onOptionClick($event)"
></app-ui-select>
